import { reviewsData, generateStars, formatReview, getRandomReviews } from './reviews-data.js';

class ReviewsManager {
    constructor() {
        this.initialized = false;
        this.currentReviews = [];
        this.init();
    }

    init() {
        if (this.initialized) return;
        
        console.log('🌟 Reviews Manager initializing...');
        
        // Wait for DOM to be ready
        if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', () => this.setup());
        } else {
            this.setup();
        }
        
        this.initialized = true;
    }

    setup() {
        this.updateHeroReviews();
        this.loadReviewsSection();
        this.addEventListeners();
        console.log('✅ Reviews system loaded successfully');
    }

    updateHeroReviews() {
        const ratingScore = document.getElementById('hero-rating-score');
        const ratingCount = document.getElementById('hero-rating-count');
        const ratingStars = document.getElementById('hero-rating-stars');

        if (ratingScore) ratingScore.textContent = reviewsData.overall.rating.toFixed(1);
        if (ratingCount) ratingCount.textContent = `${reviewsData.overall.totalReviews} Bewertungen`;
        if (ratingStars) {
            ratingStars.innerHTML = '';
            const starsElement = this.createSafeStarsElement(reviewsData.overall.rating);
            ratingStars.appendChild(starsElement);
        }
    }

    loadReviewsSection() {
        const reviewsRating = document.getElementById('reviews-rating');
        const reviewsCount = document.getElementById('reviews-count');
        const reviewsStars = document.getElementById('reviews-stars');
        const reviewsGrid = document.getElementById('reviews-grid');

        // Update overall rating display
        if (reviewsRating) reviewsRating.textContent = reviewsData.overall.rating.toFixed(1);
        if (reviewsCount) reviewsCount.textContent = `${reviewsData.overall.totalReviews} Bewertungen`;
        if (reviewsStars) {
            reviewsStars.innerHTML = '';
            const starsElement = this.createSafeStarsElement(reviewsData.overall.rating);
            reviewsStars.appendChild(starsElement);
        }

        // Load featured reviews
        if (reviewsGrid) {
            this.currentReviews = getRandomReviews(4);
            reviewsGrid.innerHTML = '';
            this.renderReviewsSafely(this.currentReviews, reviewsGrid);
            
            // Animate reviews after a short delay
            setTimeout(() => {
                this.animateReviews();
            }, 500);
        }
    }

    renderReviews(reviews) {
        return reviews.map((review, index) => `
            <div class="review-card" data-review-id="${review.id}" style="animation-delay: ${index * 0.1}s;">
                <div class="review-header">
                    <div class="reviewer-info">
                        ${review.avatar}
                        <div class="reviewer-details">
                            <div class="reviewer-name">${review.author}</div>
                            <div class="review-date">${review.date}</div>
                        </div>
                    </div>
                    <div class="review-stars">${review.starsHtml}</div>
                </div>
                <div class="review-text">${review.text}</div>
                <div class="review-helpful">
                    <i class="fas fa-thumbs-up"></i>
                    ${review.helpful} fanden das hilfreich
                </div>
            </div>
        `).join('');
    }

    // NEUE SICHERE RENDER METHODEN
    createSafeStarsElement(rating) {
        const container = document.createElement('div');
        container.className = 'stars-container';
        
        const fullStars = Math.floor(rating);
        const partial = rating % 1;
        const emptyStars = 5 - fullStars - (partial > 0 ? 1 : 0);
        
        // Full stars
        for (let i = 0; i < fullStars; i++) {
            const star = document.createElement('span');
            star.className = 'star full-star';
            star.textContent = '★';
            container.appendChild(star);
        }
        
        // Partial star
        if (partial > 0) {
            const star = document.createElement('span');
            star.className = 'star partial-star';
            star.textContent = '★';
            container.appendChild(star);
        }
        
        // Empty stars
        for (let i = 0; i < emptyStars; i++) {
            const star = document.createElement('span');
            star.className = 'star empty-star';
            star.textContent = '☆';
            container.appendChild(star);
        }
        
        return container;
    }

    renderReviewsSafely(reviews, container) {
        reviews.forEach((review, index) => {
            const reviewCard = document.createElement('div');
            reviewCard.className = 'review-card';
            reviewCard.dataset.reviewId = review.id;
            reviewCard.style.animationDelay = `${index * 0.1}s`;

            // Review Header
            const reviewHeader = document.createElement('div');
            reviewHeader.className = 'review-header';

            // Reviewer Info
            const reviewerInfo = document.createElement('div');
            reviewerInfo.className = 'reviewer-info';

            // Avatar (already sanitized in reviews-data.js)
            const avatarDiv = document.createElement('div');
            avatarDiv.innerHTML = review.avatar; // This is safe as it's pre-sanitized
            reviewerInfo.appendChild(avatarDiv.firstElementChild);

            // Reviewer Details
            const reviewerDetails = document.createElement('div');
            reviewerDetails.className = 'reviewer-details';

            const reviewerName = document.createElement('div');
            reviewerName.className = 'reviewer-name';
            reviewerName.textContent = review.author; // Safe: using textContent

            const reviewDate = document.createElement('div');
            reviewDate.className = 'review-date';
            reviewDate.textContent = review.date; // Safe: using textContent

            reviewerDetails.appendChild(reviewerName);
            reviewerDetails.appendChild(reviewDate);
            reviewerInfo.appendChild(reviewerDetails);

            // Review Stars
            const reviewStars = document.createElement('div');
            reviewStars.className = 'review-stars';
            reviewStars.appendChild(this.createSafeStarsElement(review.rating));

            reviewHeader.appendChild(reviewerInfo);
            reviewHeader.appendChild(reviewStars);

            // Review Text
            const reviewText = document.createElement('div');
            reviewText.className = 'review-text';
            reviewText.textContent = review.text; // Safe: using textContent

            // Review Helpful
            const reviewHelpful = document.createElement('div');
            reviewHelpful.className = 'review-helpful';

            const thumbsIcon = document.createElement('i');
            thumbsIcon.className = 'fas fa-thumbs-up';
            reviewHelpful.appendChild(thumbsIcon);

            const helpfulText = document.createTextNode(` ${review.helpful} fanden das hilfreich`);
            reviewHelpful.appendChild(helpfulText);

            // Assemble review card
            reviewCard.appendChild(reviewHeader);
            reviewCard.appendChild(reviewText);
            reviewCard.appendChild(reviewHelpful);

            container.appendChild(reviewCard);
        });
    }

    animateReviews() {
        const reviewCards = document.querySelectorAll('.review-card');
        reviewCards.forEach((card, index) => {
            setTimeout(() => {
                card.classList.add('slide-in');
            }, index * 150);
        });
    }

    rotateReviews() {
        console.log('🔄 Rotating reviews...');
        const reviewsGrid = document.getElementById('reviews-grid');
        if (!reviewsGrid) return;

        // Fade out current reviews
        const currentCards = reviewsGrid.querySelectorAll('.review-card');
        currentCards.forEach(card => {
            card.style.opacity = '0';
            card.style.transform = 'translateY(20px)';
        });

        // Load new reviews after fade out
        setTimeout(() => {
            this.currentReviews = getRandomReviews(4);
            reviewsGrid.innerHTML = '';
            this.renderReviewsSafely(this.currentReviews, reviewsGrid);
            this.animateReviews();
        }, 300);
    }

    addEventListeners() {
        // Optional: Add click handlers for review interactions
        document.addEventListener('click', (e) => {
            if (e.target.classList.contains('review-card')) {
                this.handleReviewClick(e.target);
            }
        });

        // Reviews are now fixed - no rotation needed
    }

    handleReviewClick(reviewCard) {
        const reviewId = reviewCard.dataset.reviewId;
        console.log(`Review ${reviewId} clicked`);
        
        // Add a subtle animation to show interaction
        reviewCard.style.transform = 'scale(1.02)';
        setTimeout(() => {
            reviewCard.style.transform = 'scale(1)';
        }, 150);
    }

    isReviewsSectionVisible() {
        const reviewsSection = document.getElementById('reviews');
        if (!reviewsSection) return false;
        
        const rect = reviewsSection.getBoundingClientRect();
        return (rect.top < window.innerHeight && rect.bottom > 0);
    }

    // Method to manually refresh reviews (useful for testing)
    refresh() {
        console.log('🔄 Manually refreshing reviews...');
        this.loadReviewsSection();
    }

    // Method to add a new review (for future API integration)
    addReview(review) {
        console.log('➕ Adding new review:', review);
        reviewsData.allReviews.unshift(review);
        reviewsData.overall.totalReviews++;
        this.updateHeroReviews();
        this.loadReviewsSection();
    }

    // Method for future Google Places API integration
    async fetchLiveReviews() {
        console.log('🌐 Fetching live reviews from Google Places API...');
        // This would integrate with Google Places API
        // For now, we'll simulate with our static data
        
        try {
            // Simulated API call
            await new Promise(resolve => setTimeout(resolve, 1000));
            console.log('✅ Live reviews fetched (simulated)');
            this.refresh();
        } catch (error) {
            console.error('❌ Failed to fetch live reviews:', error);
        }
    }
}

// Initialize reviews manager
const reviewsManager = new ReviewsManager();

// Export for global access (useful for debugging)
window.reviewsManager = reviewsManager;

export default reviewsManager;